import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  ActionType,
  DeleteStressCheckData,
  IDeleteStressCheckResponse,
} from "models/stressCheck/deleteStressCheck";
import { httpStatus } from "configs/httpStatus";
import { deleteStressCheck } from "services/stressCheck";
import {
  handleSuccesAction,
  handleErrorAction,
} from "./deleteStressCheckActions";

function* deleteStressCheckSaga({
  payload,
}: {
  payload: DeleteStressCheckData;
}) {
  try {
    const response: IDeleteStressCheckResponse = yield call(
      deleteStressCheck,
      payload
    );

    if (response.status === httpStatus.StatusOK) {
      yield put(handleSuccesAction(response));
    } else if (response.status === httpStatus.StatusUnauthorized) {
      yield put(handleErrorAction(response.message || ""));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onDeleteStressCheckWatcher() {
  yield takeLatest(
    ActionType.DELETE_STRESS_CHECK as any,
    deleteStressCheckSaga
  );
}

export default [fork(onDeleteStressCheckWatcher)];
